import InspecDistAddEditDialogCtrl from "./InspecDistAddEditDialogCtrl";
import InspectoresDistritosGridCtrl from "./InspectoresGridCtrl";
import AppModule from "../../app.module";
import angular from 'angular';
import ngResourceModuleName from 'angular-resource';

/**
 * Modulo para los inspectoresDistritos
 */
const InspectoresDistritosModule = angular
    .module('inspectoresDistritos', [AppModule.name, ngResourceModuleName])
    .controller('InspecDistAddEditDialogCtrl', InspecDistAddEditDialogCtrl)
    .controller('InspectoresDistritosGridCtrl', InspectoresDistritosGridCtrl)
;
export default InspectoresDistritosModule;